import React, { useState } from 'react'
//import './FilterForm.css'
import {localestr} from '../utils.js'
import EditCtrl from './EditCtrl.js'

function NumberForm({capt1,capt2,number,setModal,action}){
    const [numb,setNumb]=useState(number)

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function keyClick(e){
      if(e.key==='Enter') {setModal('');action(numb)}
      else if(e.key==='Escape') setModal('')
    }

    return(
        <div className='modal_f'><div id='modalWnd' className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{capt1}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content'>
            <div onKeyUp={keyClick} style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <EditCtrl Capt={capt2} Value={numb} typeVal={'number'} setVal={setNumb} width1='60' width2='120' isActive={true}/>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('');action(numb)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div></div>
        </div></div>
    )
}

export default NumberForm